function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M17.5 11.49c-.11.09-.22.16-.35.22l-1.09.55-3.07 1.53c-.55.28-1.44.28-1.98 0l-3.07-1.53-1.09-.55c-.12-.07-.23-.13-.35-.22-1.06-.74-1.25-2.09-.4-3.16l4.17-5.2c.26-.32.57-.56.89-.7.54-.26 1.14-.26 1.67 0 .32.14.64.38.89.7l4.17 5.2c.86 1.08.67 2.43-.39 3.16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.5 11.49c-.11.09-.22.16-.35.22l-1.09.55L12 9.21l-4.06 3.06-1.09-.55c-.12-.07-.23-.13-.35-.22.04-.19.14-.36.31-.48l4.35-3.27V2.44c.54-.26 1.14-.26 1.67 0v5.31l4.35 3.27c.17.12.27.28.32.47zm-8.73 2.94l1.61.72a4 4 0 003.25 0l1.61-.72c1.44-.64 2.77 1.1 1.77 2.32l-3.46 4.23c-.85 1.04-2.24 1.04-3.1 0L7 16.75c-1.01-1.22.32-2.96 1.77-2.32z"
})));